import { Box } from '@mui/material';
import React from 'react';
import CollaborationGroupsList from './CollaborationGroupsList';
import CollaborationGroupDetails from './CollaborationGroupDetails';
import SelectedCollaborationGroupIdProvider from './Contexts/SelectedCollaborationGroupIdContext';

const CollaborationGroupsPage: React.FC = () => {
  return (
    <SelectedCollaborationGroupIdProvider>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ minHeight: '80vh', width: '30vw', background: '#F5F5F5', borderRadius: '1rem' }}>
          <CollaborationGroupsList />
        </Box>
        <Box sx={{ minHeight: '80vh', width: '65vw', background: '#e8eef5', borderRadius: '1rem', ml: '1rem' }}>
          <CollaborationGroupDetails />
        </Box>
      </Box>
    </SelectedCollaborationGroupIdProvider>
  );
};

export default CollaborationGroupsPage;
